<template>
  <div>
    <no-data v-if="reports.length === 0" />
    <c-report-item
      v-for="(item) in reports.flat()"
      v-else
      :key="item.key"
      :data="item"
    />
  </div>
</template>

<script>
import CReportItem from '../ui/CReportItem.vue'
import NoData from '../../../../../../../resources/js/components/NoData.vue'
import apiService from '../../apiService'
import { mapGetters, mapState } from 'vuex'
import { Notification } from 'uiv'

export default {
  name: 'TmMonitoring',
  components: { CReportItem, NoData },
  data () {
    return {
      fetchingReports: false,
      reports: []
    }
  },
  computed: {
    ...mapGetters({
      getPeriod: 'Period/getPeriod'
    }),
    ...mapState({
      domainSelected: state => state.serm.client.domains.selected
    })
  },
  watch: {
    // Загрузка отчётов при изменении периода
    getPeriod: function (val) {
      if (val) {
        this.fetchReports().then(this.onReportsResolve)
      }
    }
  },
  mounted () {
    this.fetchReports().then(this.onReportsResolve)
  },
  methods: {
    /**
     * Метод-обёртка над запросом к API /api/serm/reports
     * @returns {Promise<AxiosResponse<T>>}
     */
    fetchReports () {
      this.fetchingReports = true
      return new Promise(resolve => {
        if (this.domainSelected) {
          apiService.getReports(
            this.domainSelected.url,
            this.getPeriod.from.toLocaleDateString('en-CA'), // YYYY-mm-dd
            this.getPeriod.to.toLocaleDateString('en-CA'), // YYYY-mm-dd
            'tm_monitoring'
          )
            .then(response => {
              this.fetchingReports = false
              resolve(response.data)
            })
            .catch(() => {
              this.fetchingReports = false
              Notification.notify.error({
                title: 'Ошибка',
                content: 'Не удалось загрузить отчёты.'
              })
            })
        }
      })
    },
    /**
     * Выводит данные в компонент
     * @param data Данные из Promise
     */
    onReportsResolve (data) {
      this.reports = data.reports
    }
  }
}
</script>
